import { useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM1010_R01Store } from "./Store_EQM1010_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";

export const SearchSection_EQM1010_R01 = () => {
    const { EQM1010_R01Filter, setEQM1010_R01Filter } = useEQM1010_R01Store();
    const { compCdList, plcaddressList } = useCommonCodeStore();


    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={EQM1010_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={v => setEQM1010_R01Filter({ compCd: v === 'all' ? '' : v })}
            />
            <SearchDateSingleForm
                label="조회일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={EQM1010_R01Filter.baseDate}
                onChange={(date) => setEQM1010_R01Filter({ baseDate: date })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
                
            />
            <SearchDropDownForm<SysCodeDto>
                label="데이타종류"
                value={EQM1010_R01Filter.plcaddressid?.toString() || 'all'}
                optionList={plcaddressList}
                onChangeValue={v => setEQM1010_R01Filter({ plcaddressid: (v === 'all' || v === '') ? null : Number(v) })}
                wrapperOption={{
                    selectStyle: 'w-[200px] min-w-[200px]',
                }}
            />
        </SearchSectionForm>
    );
};
